import { useMemo } from 'react';
import { css, cx } from '@linaria/atomic';
import { SKELETON_BASE, SKELETON_RECTANGLE, SKELETON_SHIMMER } from '../../loader/loaders.styles';

interface Props {
  fullWidth?: boolean;
}

const MIN_WIDTH = 60;
const MAX_WIDTH = 100;

const skeletonHeightStyle = css`
  height: 1.5em;
`;

const skeletonFullWidthStyle = css`
  width: 100%;
`;

export const TableLoadingSkeleton = ({ fullWidth }: Props) => {
  function randomWidth(min: number, max: number): number {
    return Math.floor(Math.random() * (max - min) + min);
  }

  const randomInteger = useMemo(() => randomWidth(MIN_WIDTH, MAX_WIDTH), []);

  return (
    <div
      className={cx(
        SKELETON_BASE,
        SKELETON_RECTANGLE,
        SKELETON_SHIMMER,
        skeletonHeightStyle,
        fullWidth && skeletonFullWidthStyle
      )}
      style={!fullWidth ? { width: `${randomInteger}%` } : undefined}
    />
  );
};
